import React, { useRef, useEffect, useState } from "react";
import { BehiveDataCard, BehiveGraphCard } from "../cards/manager";
import { useManagerContext } from "@src/context/managerContext";
import { SignolUtils } from "@src/utils";

const BehiveCell = (props) => {
  const { layoutInfo, data, rowLength, behaviourCardClickThroughHandler } =
    props;
  const { profile } = useManagerContext();

  const wrapperRef = useRef(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    setWidth(wrapperRef.current ? wrapperRef.current.offsetWidth : 0);
  }, [wrapperRef]);
  let cellJSON = null;
  if (layoutInfo.data && Array.isArray(layoutInfo.data)) {
    const dataArray = [];
    for (let o = 0; o < layoutInfo.data.length; o++) {
      if (layoutInfo.data[o]) {
        const content = data.graphs.find(
          (obj) =>
            obj.key === SignolUtils.normalizeBehiveKey(layoutInfo.data[o]),
        )?.content;
        if (content) dataArray.push(JSON.parse(content));
      }
    }
    cellJSON = JSON.stringify(dataArray);
  } else {
    cellJSON = data.graphs.find(
      (obj) => obj.key === SignolUtils.normalizeBehiveKey(layoutInfo.data),
    )?.content;
  }
  const cellData = cellJSON ? JSON.parse(cellJSON) : null;

  return (
    <>
      {!cellData && <div>No Data</div>}
      {cellData && (
        <div ref={wrapperRef} className="w-full h-full">
          {layoutInfo.contentType === "graph" ||
          layoutInfo.contentType === "generic_graph" ? (
            <BehiveGraphCard
              layoutData={layoutInfo}
              dataJSON={cellData}
              width={width}
              padding={width / rowLength}
            />
          ) : (
            <BehiveDataCard
              layoutData={layoutInfo}
              dataJSON={cellData}
              industry={profile.customer.industry}
              customerCode={profile.customer.customerCode}
              behaviours={profile.behaviours}
              behaviourCardClickThroughHandler={
                behaviourCardClickThroughHandler
              }
            />
          )}
        </div>
      )}
    </>
  );
};
export default BehiveCell;
